import { api } from './api';

const getCardOrderReport = async ({orderId}) => {
    const response = await api({
        url: `Report/cardOrderReport`,
        method: 'GET',
        params: {
            orderId,
        },
        responseType: 'blob',
    });
    return response.data;
};

const getBalanceOrderReport = async ({orderId}) => {
    const response = await api({
        url: `Report/loadBalanceReport`,
        method: 'GET',
        params: {
            orderId,
        },
        responseType: 'blob',
    });
    return response.data;
};

const getOrderReport = async (data) => {
    const response = await api({
        url: `Report/orderReport`,
        method: 'GET',
        params: data,
        responseType: 'blob',
    });
    return response.data;
};

const getOrderSummaryPdfReport = async (data) => {
    const response = await api({
        url: `Report/orderSummaryReport`,
        method: 'GET',
        params: data,
        responseType: 'arraybuffer',
    });
    return response.data;
};

const getAutoLoadingReport = async ({customerId, vouId, id}) => {
    const response = await api({
        url: `Report/autoLoadingReport`,
        method: 'GET',
        params: {
            customerId,
            vouId,
            id,
        },
        responseType: 'blob',
    });
    return response.data;
};

const reports = {
  getCardOrderReport,
  getBalanceOrderReport,
  getOrderReport,
  getOrderSummaryPdfReport,
  getAutoLoadingReport,
};

export default reports;
